module.exports = __webpack_public_path__ + "static/media/hogar_madera.2ce6f89b.svg";